import { ContactUsForm } from "../components/sections/contact/ContactUsForm";
import { FrequentlyAskedQuestions } from "../components/sections/contact/FrequentlyAskedQuestions";

export const ContactScreen = () => {
  return (
    <>
      <FrequentlyAskedQuestions />
      <ContactUsForm />
    </>
  )
};